import { ModalControlsSaveableFactory } from '®shared/modals';

import {
  ReportBrokenLinkActionTypes,
  ReportBrokenLinkActions,
} from './report-broken-link.actions';
import {
  REPORT_BROKEN_LINK_INITIAL_STATE,
  ReportBrokenLinkState,
} from './report-broken-link.state';

export function reportBrokenLinkReducer(
  state: ReportBrokenLinkState,
  action: ReportBrokenLinkActions,
): ReportBrokenLinkState {
  switch (action.type) {
    case ReportBrokenLinkActionTypes.SHOW_REPORT_BROKEN_LINK_MODAL: {
      return {
        ...state,
        currentItem: action.payload.item,
        modalControl: ModalControlsSaveableFactory.show(),
        user: action.payload.user,
      };
    }

    case ReportBrokenLinkActionTypes.REPORT_BROKEN_LINK: {
      return {
        ...state,
        brokenLinkReport: action.payload.brokenLinkReport,
        currentItem: action.payload.brokenLinkReport.item,
        modalControl: ModalControlsSaveableFactory.saving(),
      };
    }

    case ReportBrokenLinkActionTypes.HIDE_REPORT_BROKEN_LINK_MODAL: {
      return REPORT_BROKEN_LINK_INITIAL_STATE;
    }

    case ReportBrokenLinkActionTypes.REPORT_BROKEN_LINK_FAILED: {
      return {
        ...state,
        modalControl: ModalControlsSaveableFactory.errorSaving(
          action.payload.error,
        ),
      };
    }

    default: {
      return state;
    }
  }
}
